<template>
  <div
    :id="$attrs._id"
    class="tag-basic-icon"
    :dir="language.dir"
    :style="styles"
  >
    <fa class="tag-basic-icon__icon" :icon="['fad', faIcon]"/>
    <div class="tag-basic-icon__label" v-html="label[language.code]"></div>
  </div>
</template>
<script>
export default {
  props: ['pos', 'label', 'icon', 'background-colour', 'text-colour'],

  computed: {
    faIcon () {
      return this.icon || 'car'
    },

    language () {
      return this.$store.getters.language
    },

  styles () {
      const style = {
        // position
        left: `${(this.pos.x / 20)}em`,
        top: `${(this.pos.y / 20)}em`,
      }

      // feed per-tag colours into CSS vars, if present
      if (this.backgroundColour) {
        style['--tag-basic-icon-bg-color'] = this.backgroundColour
      }
      if (this.textColour) {
        style['--tag-basic-icon-font-color'] = this.textColour
      }

      return style
    }
  },
}
</script>
<style lang="scss" scoped>
.tag-basic-icon {
  background-color: var(--tag-basic-icon-bg-color);
  border-radius: 50%;
  box-shadow: var(--tag-box-shadow);
  color: #fff;
  display: flex;
  font-size: 1em;
  height: 2.5em;
  letter-spacing: .05em;
  line-height: 1.2em;
  padding: 0;
  pointer-events: auto;
  position: absolute;
  width: 2.5em;
  z-index: var(--tag-z-index);

  opacity: 0;
  transform: translateY(1rem);

  &.enter {
    opacity: 1;
    transform: translateY(0);
    transition: opacity 1.2s, transform 0.6s;
  }

  &::before{
    background: var(--tag-basic-icon-bg-color);
    bottom: 100%;
    box-shadow: var(--tag-box-shadow);
    content: '';
    height: 2.5rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: .25em;
  }

  &__label {
    background-color: var(--tag-basic-icon-bg-color);
    border-radius: var(--border-radius);
    box-shadow: var(--tag-box-shadow);
    color: var(--tag-basic-icon-font-color);
    font-size: 0.65em;
    font-weight: var(--font-weight-secondary);
    left: 50%;
    letter-spacing: .1em;
    line-height: 1.2em;
    width: max-content;
    padding: 0.4em 1.2em 0.2em;
    pointer-events: auto;
    position: absolute;
    text-align: center;
    text-transform: uppercase;
    transform: translate(-50%, -5em);
    user-select: none;
  }

  &__icon {
    font-size: 1.5em;
    margin: auto;
    color: var(--tag-basic-icon-font-color);
  }
}
</style>
